import { openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24cc44a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "info" }
const _hoisted_3 = {
  key: 0,
  class: "price"
}
const _hoisted_4 = {
  class: "ori-price",
  style: {"color":"var(--activeColor)"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 原价", -1))
const _hoisted_7 = {
  key: 0,
  class: "member-price"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, " 会员价", -1))
const _hoisted_10 = {
  key: 1,
  class: "price"
}
const _hoisted_11 = {
  class: "ori-price",
  style: {"color":"var(--activeColor)"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_13 = {
  key: 0,
  class: "member-price"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, " 会员价", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  class: "code",
  style: {"justify-content":"space-between","padding-right":"10px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#808080"} }, "款号:", -1))
const _hoisted_19 = { style: {"font-weight":"bold","color":"gray"} }
const _hoisted_20 = { class: "command" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({width:_ctx.width+'px',..._ctx.coverStyle}),
    class: "main mobile-product-card"
  }, [
    _createElementVNode("div", {
      class: "image",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cardClick && _ctx.cardClick(...args)))
    }, [
      (_openBlock(), _createElementBlock("img", {
        key: _ctx.coverAttempt,
        src: _ctx.cachedCoverUrl,
        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCoverError && _ctx.handleCoverError(...args))),
        alt: ""
      }, null, 40, _hoisted_1)),
      (_ctx.imageFailed)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.retryImage && _ctx.retryImage(...args)), ["stop"])),
            style: {"position":"absolute","inset":"auto 8px 8px","border":"0","border-radius":"4px","padding":"8px","background":"#fff","color":"#1677ff","cursor":"pointer"}
          }, "图片加载失败，点击重试"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.value.price2<_ctx.value.price1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.value.price2), 1),
              _hoisted_6
            ]),
            (_ctx.value.price2!=_ctx.value.price1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(_ctx.value.price1), 1),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", null, _toDisplayString(_ctx.value.price2), 1)
            ]),
            (_ctx.value.price2!=_ctx.value.price1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", null, _toDisplayString(_ctx.value.price1), 1),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cardClick && _ctx.cardClick(...args))),
        class: "desc"
      }, [
        _createElementVNode("a", {
          href: "#",
          title: _ctx.displayDescription
        }, _toDisplayString(_ctx.displayDescription), 9, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", null, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.value.code), 1)
        ]),
        (_ctx.clientFunctionVisible('收藏列表'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['btn-sc',_ctx.value.favorite>0?'btn-sc1':'']),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addFavorite && _ctx.addFavorite(...args)))
            }, "收藏", 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.value.presale && _ctx.value.presale>0 && _ctx.previliges['成衣预定浏览与下单'])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['btn-sc','btn-sc1']),
              style: {"width":"60px"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cardClick && _ctx.cardClick(...args)))
            }, "接受预定"))
          : _createCommentVNode("", true)
      ])
    ])
  ], 4))
}